module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/thurston_promo_custom.897d1cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/thurston_promo_custom.jpg
// module id = aOIn
// module chunks = 1